import { urlForMedia } from '../services/apiService';
import { staticTranslation } from '../services/staticTranslations';
import { ActionButton } from './actionButton';

const DownloadButton = (props) => {
  const propStyle = props.style || {};
  const fileId = props.fileId || null;
  const title =
    props.children || props.title || staticTranslation('Download Action');
  const url = urlForMedia(fileId);

  return (
    <ActionButton style={propStyle} action={() => window.open(url, '_blank')}>
      {title}
    </ActionButton>
  );
};

export { DownloadButton };
